import './../../styles/templates/404.scss';

$(function () {
  const related_products_404 = document.getElementById('related-products-404');
  if (related_products_404) {
    var terms = location.pathname.split('/');
    var term = terms[terms.length - 1];
    fetch("/search/suggest.json?q=" + term + "&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title")
      .then((response) => response.json())
      .then((suggestions) => {
        var productSuggestions = suggestions.resources.results.products;
        var results = [];

        //FIRST STEP
        for (var i = 0; i < productSuggestions.length; i++) {
          results.push(productSuggestions[i]);
        }

        //SECOND STEP
        if (productSuggestions.length > 0 && results.length < 4) {
          var firstProductSuggestion = productSuggestions[0]; //select only the first suggestion
          //console.log(firstProductSuggestion);
          var tags = firstProductSuggestion.tags;

          for (var i = 0; i < tags.length; i++) {
            if (tags[i].startsWith("SOTTOCATEGORIA_")) {
              //console.log(tags[i]);
              fetch("/search/suggest.json?q=" + tags[i] + "&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=tag")
                .then((response2) => response2.json())
                .then((suggestions2) => {
                  var otherProductsWithSameTagSottocagetoria = suggestions2.resources.results.products;
                  if (otherProductsWithSameTagSottocagetoria.length > 1) {
                    for (var j = 0; j < otherProductsWithSameTagSottocagetoria.length; j++) {
                      results.push(otherProductsWithSameTagSottocagetoria[j]);
                    }
                  }
                })
            }
          }

          //THIRD STEP
          if (results.length < 4) {   //depends on how much suggestion we want (But at this point the reults are always 0 beacause it's asynchronous => make it synchronous)
            for (var i = 0; i < tags.length; i++) {
              if (tags[i].startsWith("CATEGORIA_")) {
                //console.log(tags[i]);
                fetch("/search/suggest.json?q=" + tags[i] + "&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=tag")
                  .then((response2) => response2.json())
                  .then((suggestions2) => {
                    var otherProductsWithSameTagCategoria = suggestions2.resources.results.products;
                    if (otherProductsWithSameTagCategoria.length > 1) {
                      for (var j = 0; j < otherProductsWithSameTagCategoria.length; j++) {
                        results.push(otherProductsWithSameTagCategoria[j]);
                      }
                      createProducts(results);
                    }
                  })
              }
            }
          } else {
            createProducts(results);
          }
        } else {
          createProducts(results);
        }

      }
      );

    function createProducts(products) {
      // create product tiles
      if (products.length > 0) {
        var content_html = "";
        for (let i = 0; i < products.length && i < 4; i++) {
          const product = products[i];
          content_html += '<div class="product-404">';

          content_html += '<div class="product-404__image" data-link-proxy="' + product.url + '">';
          content_html += '<img src="' + product.featured_image.url + '" alt="' + product.featured_image.alt + '" width="' + (product.featured_image.width / 2) + '" height="' + (product.featured_image.height / 2) + '" />';
          content_html += '</div>';

          content_html += '<div class="product-404__title"><a href="' + product.url + '">' + product.title + '</a></div>';

          content_html += '</div>';
        }

        document.querySelector('.related-products-404__container').innerHTML = content_html;

        if ($(window).width() <= 768) {
          $('.related-products-404__container').slick({
            dots: true,
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            autoplay: false,
            slidesToShow: 2
          });
        }

        $('.related-products-404__container [data-link-proxy]').ProxyLink();
        related_products_404.classList.remove('hide');
      }
    }
  }
});
